import on from '../lib/on';
import setAttributes from '../lib/set-attributes';
import scrollToElement from '../lib/scroll-to-element';

const moduleSelector = '.js-tabs';
const moduleCallBack = (moduleElement, query, queryAll) => {
    const tabControl = queryAll('.js-tabs-button');
    const tabContent = queryAll('.js-tabs-content');
    const setTab = (linkElement) => {
        const index = parseInt(linkElement.dataset.index, 10);

        tabControl.forEach((item) => {
            item.classList.remove('active');
            setAttributes(item, {
                'aria-selected': 'false',
            });
        });
        tabControl[index].classList.add('active');
        setAttributes(tabControl[index], {
            'aria-selected': 'true',
        });

        tabContent.forEach((item) => {
            item.classList.remove('active');
            setAttributes(item, {
                'aria-hidden': 'true',
            });
        });
        tabContent[index].classList.add('active');
        setAttributes(tabContent[index], {
            'aria-hidden': 'false',
        });
    };
    if (tabControl) {
        // eslint-disable-next-line func-names
        on(tabControl, 'click', function (e) {
            e.preventDefault();
            setTab(this);
            scrollToElement(moduleElement, 0.8);
        });
        // eslint-disable-next-line func-names
        on(tabControl, 'keydown', function (e) {
            if (e.code.toLowerCase() === 'enter') {
                setTab(this);
                scrollToElement(moduleElement, 0.8, 50);
            }
        });
    }
};

export { moduleSelector, moduleCallBack };
